import React, { useEffect, useState } from 'react';
import icon from '../assets/indian-flag.png';
import { login } from '../Utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OTPScreen from './OTPScreen';
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomerDetails, updateClickId } from '../CustomerJourneyDetails/CustomerJourneyDetails';
import { Link } from 'react-router-dom';



export default function MobileRegister() {
  
  const [mobileNumber, setMobileNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isAgreed1, setIsAgreed1] = useState(true);
  const [isAgreed2, setIsAgreed2] = useState(true);
  const [agreeError1, setAgreeError1] = useState('');
  const [agreeError2, setAgreeError2] = useState('');
  const [otpScreen, setOtpScreen] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const dispatch = useDispatch();
  useSelector((state) => state.customerJourneyDetails.customerDetails);

  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      click_id: params.get('click_id') || '',
    };
  };

  useEffect(() => {
    const { click_id } = getUtmParams();
    if (click_id) dispatch(updateClickId(click_id));
  }, [dispatch]);

  const validateMobile = (number) => {
    if (!number) return 'Please enter your mobile number';
    if (!/^[6-9]\d{9}$/.test(number)) return 'Please enter a valid 10-digit Indian mobile number';
    return '';
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); sendOTP(); }
  };

  const sendOTP = async (mobile = mobileNumber) => {
    if (isVerifying) return;

    let hasError = false;
    if (!isAgreed1) { setAgreeError1('Please accept the Terms & Conditions.'); hasError = true; }
    else setAgreeError1('');
    if (!isAgreed2) { setAgreeError2('Please consent to receive notifications.'); hasError = true; }
    else setAgreeError2('');
    if (hasError) return;

    const validationError = validateMobile(mobile);
    if (validationError) { setErrorMessage(validationError); return; }

    setErrorMessage('');
    setIsVerifying(true);

    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content,click_id } = getUtmParams();
    const param = {
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term,
      utmClickId:click_id,
      utm_content,
      mobile,
      sourceId: 1,
    };

    try {
      const response = await login(param);
      if (response?.data?.apiStatus === 1) {
        toast.success(response?.data?.message || 'OTP sent successfully');
        dispatch(updateCustomerDetails({ profileId: response?.data?.data?.profileId, mobile,utm_source }));
        setOtpScreen(true);
      } else {
        setErrorMessage(response?.data?.message || 'Login failed. Please check your number and try again.');
      }
    } catch (error) {
      console.error('Login Failed:', error);
      setErrorMessage('Login failed. Please check your number and try again.');
    } finally {
      setIsVerifying(false);
    }
  };

  if (otpScreen) return <OTPScreen />;

  return (
    <>
      

      {/* Card — no outer pageWrap; centering done by parent .login-right */}
      <div style={s.card}>

        <div style={s.brandBar}>
          <div style={s.brandDot} />
          <span style={s.brandLabel}>Secure Login</span>
        </div>

        <p style={s.cardTitle}>Welcome back</p>
        <p style={s.cardSub}>Enter your mobile number to receive an OTP</p>

        <div style={s.inputLabelRow}>
          <span style={s.inputLabel}>Mobile number</span>
          <span style={s.counter}>{mobileNumber.length}/10 digits</span>
        </div>

        <div style={{ ...s.inputRow, ...(isFocused ? s.inputRowFocused : {}) }}>
          <div style={s.flagBox}>
            <img src={icon} alt="India" style={s.flagImg} />
            <span style={s.flagCode}>+91</span>
          </div>

          <input
            type="text"
            inputMode="numeric"
            maxLength="10"
            placeholder="Enter Mobile Number"
            value={mobileNumber}
            style={s.mobileInput}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              setMobileNumber(value);
              setErrorMessage('');
            }}
          />

          <button
            style={{ ...s.otpBtn, ...(isVerifying ? s.otpBtnDisabled : {}) }}
            onClick={() => sendOTP(mobileNumber)}
            disabled={isVerifying}
            onMouseEnter={(e) => { if (!isVerifying) e.currentTarget.style.background = '#ea6c0a'; }}
            onMouseLeave={(e) => { if (!isVerifying) e.currentTarget.style.background = '#F97316'; }}
          >
            {isVerifying ? 'Sending…' : 'Get OTP'}
          </button>
        </div>

        {errorMessage && <p style={s.errorMsg}>{errorMessage}</p>}

        <hr style={s.divider} />

        {/* Checkbox 1 */}
        <div style={s.checkRow}>
          <input
            type="checkbox"
            checked={isAgreed1}
            style={s.checkBox}
            onChange={(e) => { setIsAgreed1(e.target.checked); setAgreeError1(''); }}
          />
          <span style={s.checkText}>
            I agree to the{' '}
            <Link to="/terms-and-conditions" target="_blank" style={s.checkLink}>Terms &amp; Conditions</Link>
            {' '}and{' '}
            <Link to="/privacy-policy" target="_blank" style={s.checkLink}>Privacy Policy</Link>.
          </span>
        </div>
        {agreeError1 && <p style={s.checkError}>{agreeError1}</p>}

        {/* Checkbox 2 */}
        <div style={s.checkRow}>
          <input
            type="checkbox"
            checked={isAgreed2}
            style={s.checkBox}
            onChange={(e) => { setIsAgreed2(e.target.checked); setAgreeError2(''); }}
          />
          <span style={s.checkText}>
            I agree to receive Messages, Emails, RCS, SMS, Calls, and WhatsApp
            communications, along with updates to my mobile number or email.
          </span>
        </div>
        {agreeError2 && <p style={s.checkError}>{agreeError2}</p>}

        <div style={s.footerNote}>
          <div style={s.secureBadge}>🔒 256-bit encrypted &amp; secure</div>
        </div>
      </div>
    </>
  );
}

const s = {
  card: {
    background: '#ffffff',
    borderRadius: '20px',
    padding: '2rem 2rem 1.75rem',
    width: '100%',
    maxWidth: '440px',
    border: '0.5px solid rgba(37, 99, 235, 0.12)',
    boxShadow: '0 4px 32px rgba(37, 99, 235, 0.07)',
  },
  brandBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '1.75rem',
  },
  brandDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: '#F97316',
    flexShrink: 0,
  },
  brandLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#64748b',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: '600',
    color: '#1e3a5f',
    marginBottom: '4px',
  },
  cardSub: {
    fontSize: '14px',
    color: '#64748b',
    marginBottom: '1.5rem',
  },
  inputLabelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
  },
  inputLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#64748b',
  },
  counter: {
    fontSize: '12px',
    color: '#94a3b8',
  },
  inputRow: {
    display: 'flex',
    alignItems: 'center',
    border: '1.5px solid #bfdbfe',
    borderRadius: '12px',
    overflow: 'hidden',
    background: '#f0f7ff',
    transition: 'border-color 0.2s, background 0.2s',
  },
  inputRowFocused: {
    borderColor: '#F97316',
    background: '#ffffff',
  },
  flagBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '0 12px',
    borderRight: '1.5px solid #bfdbfe',
    height: '52px',
    background: '#e8f2ff',
    minWidth: '68px',
    flexShrink: 0,
  },
  flagImg: {
    width: '22px',
    height: '16px',
    borderRadius: '2px',
    objectFit: 'cover',
  },
  flagCode: {
    fontSize: '13px',
    color: '#1e3a5f',
    fontWeight: '600',
  },
  mobileInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    padding: '0 14px',
    fontSize: '15px',
    color: '#1e3a5f',
    height: '52px',
    fontFamily: 'inherit',
    letterSpacing: '0.5px',
    minWidth: 0,
  },
  otpBtn: {
    background: '#F97316',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '0 18px',
    height: '38px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    margin: '7px 8px 7px 0',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    letterSpacing: '0.2px',
    transition: 'background 0.18s, transform 0.1s',
    fontFamily: 'inherit',
  },
  otpBtnDisabled: {
    background: '#fbb98a',
    cursor: 'not-allowed',
  },
  errorMsg: {
    fontSize: '13px',
    color: '#dc2626',
    marginTop: '6px',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #dbeafe',
    margin: '1.25rem 0',
  },
  checkRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '10px',
  },
  checkBox: {
    width: '16px',
    height: '16px',
    borderRadius: '4px',
    marginTop: '2px',
    flexShrink: 0,
    accentColor: '#F97316',
    cursor: 'pointer',
  },
  checkText: {
    fontSize: '13px',
    color: '#475569',
    lineHeight: '1.55',
  },
  checkLink: {
    color: '#F97316',
    textDecoration: 'none',
    fontWeight: '500',
  },
  checkError: {
    fontSize: '12px',
    color: '#dc2626',
    marginTop: '2px',
    marginLeft: '26px',
    marginBottom: '6px',
  },
  footerNote: {
    textAlign: 'center',
    marginTop: '1.25rem',
    paddingTop: '1rem',
    borderTop: '1px solid #dbeafe',
  },
  secureBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    background: 'rgb(231, 240, 253)',
    borderRadius: '20px',
    padding: '4px 12px',
    fontSize: '12px',
    color: '#1e40af',
  },
};
